import { SystemField } from "./system-field";

export class PurchaseBillDetail extends SystemField{
     
     bill_id?:string;
     product_id?:string;
     unit_cost?:number;
     service_date?:string;
     discount_amount?:number;
     discount_rate?:number;
     pr_id?:string;
     qty?:number;
}
export class PurchaseBillDetailTranslation extends SystemField{
     
     lang_code?:string;
     comments?:string;
     bill_detail_id?:string;
}